import type { InvitationType } from '../../../../hooks/use-complete-invitation/invitation';

type InvitationLink = {
  email?: string | null | undefined;
  id?: string | null | undefined;
  region?: string | null | undefined;
  token?: string | null | undefined;
  type?: string | null | undefined;
};

const isValidInvitationType = (
  type: string | null | undefined
): type is InvitationType => {
  return ['student', 'teacher', 'parent'].includes(type || '');
};

const isValidInvitationId = (id: string | null | undefined): boolean => {
  return !!id;
};

const isValidInvitationToken = (token: string | null | undefined): boolean => {
  return !!token;
};

const isValidInvitationEmail = (email: string | null | undefined): boolean => {
  return !!email;
};

const isValidInvitationRegion = (
  region: string | null | undefined
): boolean => {
  return !!region;
};

const isValidInvitationLink = ({
  email,
  id,
  region,
  token,
  type,
}: InvitationLink): boolean => {
  return (
    isValidInvitationEmail(email) &&
    isValidInvitationId(id) &&
    isValidInvitationRegion(region) &&
    isValidInvitationToken(token) &&
    isValidInvitationType(type)
  );
};

export { isValidInvitationLink };
